import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-text-center" }
const _hoisted_2 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Da pagare: ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Effettuato il ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 2 }

import { PaymentType } from '@/model/Entity';
import { PaymentStatusEnum } from '@/model/Order';


export default /*#__PURE__*/_defineComponent({
  props: {
    payment_type: { type: null, required: true },
    payment_status: { type: null, required: true },
    payment_amount: { type: Number, required: true },
    paid_at: { type: null, required: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_DateFormatted = _resolveComponent("DateFormatted")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`order.payment_type_${__props.payment_type}`)), 1)
    ]),
    (__props.payment_type === 10)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.payment_status === 10)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(__props.payment_amount) + "€ ", 1)
              ]))
            : _createCommentVNode("", true),
          (__props.payment_status === 20)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_DateFormatted, { value: __props.paid_at }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (__props.payment_status === 30)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Rimborsato "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})